// WhatsAppIntegration.js (Refactored)
import React, { Component } from "react";
import {
  Section,
  SectionHeader,
  Grid,
  IntegrationCard,
  Button,
  LoadingSpinner,
} from "./DynamicIntegrationLayout";
import { initialIntegrationsData, mergeProviderStatus } from "./integartionHelper";
import toastr from "toastr";

class WhatsAppIntegration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      whatsappWalletBalance: 0,
      providers: initialIntegrationsData.whatsapp.providers,
    };

    this.providerIcons = {
      Twilio: "📞",
      Gupshup: "💬",
      AiSensy: "🤖",
      Posible: "✨",
      Meta: "🔵",
    };
  }

  componentDidMount() {
    if (this.props.registrationId) {
      this.fetchProviders();
      this.fetchWalletBalance();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.registrationId &&
      prevProps.registrationId !== this.props.registrationId
    ) {
      this.fetchProviders();
      this.fetchWalletBalance();
    }
  }

  providerIconGetter = (providerName) => {
    return this.providerIcons[providerName] || "🔧";
  };

  fetchProviders = async () => {
    if (!this.props.registrationId) return;

    try {
      this.setState({ loading: true });
      const data = await this.props.getWhatsappAllProviders(this.props.registrationId);

      if (!data || data.code !== "0") {
        toastr.error("Unable to fetch whatsapp Providers");
        return;
      }

      const mergedProviders = mergeProviderStatus(
        initialIntegrationsData.whatsapp.providers,
        data.data
      );

      this.setState({ providers: mergedProviders });
    } catch (err) {
      console.log(err, "while fetching providers");
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchWalletBalance = async () => {
    if (!this.props.registrationId) return;

    try {
      const data = await this.props.getWalletBalance(this.props.registrationId);
      if (!data || data.code !== "0") return;
      this.setState({
        whatsappWalletBalance: data.data && data.data.amount ? data.data.amount : 0,
      });
    } catch (err) {
      console.log(err, "wallet error");
      this.setState({ whatsappWalletBalance: 0 });
    }
  };

  handleSetupClick = async (providerName) => {
    const registrationId = this.props.registrationId;
    const providers = this.state.providers;

    if (providerName === "Posible") {
      try {
        this.setState({ loading: true });
        const data = await this.props.setupCredentials(
          { senderId: "" },
          registrationId,
          providerName
        );

        if (data && data.code === "0") {
          toastr.success("Posible setup successfully");
          this.fetchProviders();
          this.props.history.push({
            pathname: "/payment/payment-options/whatsapp",
          });
        } else {
          toastr.error("Failed to setup Posible");
        }
      } catch (err) {
        toastr.error("Setup error");
      } finally {
        this.setState({ loading: false });
      }
      return;
    }

    let providerMeta = null;
    for (let i = 0; i < providers.length; i++) {
      if (providers[i].name === providerName) {
        providerMeta = providers[i];
        break;
      }
    }

    this.props.history.push({
      pathname: "/integration/whatsapp/credentials-verify",
      state: {
        mode: providerMeta && providerMeta.isSetupDone ? "edit" : "setup",
        registrationId: registrationId,
        provider: providerName,
        credentials: providerMeta && providerMeta.credentials ? providerMeta.credentials : {},
        _id: providerMeta && providerMeta.id ? providerMeta.id : null,
      },
    });
  };

  handleManageTemplatesClick = (providerName, providerId) => {
    this.props.history.push({
      pathname: "/integration/templates/" + providerName + "/" + providerId,
    });
  };

  handleToggleActive = async (providerId) => {
    if (!providerId) return;

    try {
      this.setState({ loading: true });
      const data = await this.props.toggleProvidersActive(providerId);
      if (data && data.code === "0") {
        toastr.success("Status updated");
        this.fetchProviders();
      } else {
        toastr.error("Toggle failed");
      }
    } catch (err) {
      toastr.error("Toggle error");
    } finally {
      this.setState({ loading: false });
    }
  };

  renderProviderCard = (provider) => {
    const isSetup = provider.isSetupDone;
    const isActive = provider.isActive;
    const showWallet = provider.name === "Posible" && isSetup;

    const actions = isSetup
      ? [
          <Button
            key="templates"
            onClick={() => this.handleManageTemplatesClick(provider.name, provider.id)}
            icon="📋"
          >
            Manage Templates
          </Button>,
          provider.name === "Posible" ? (
            <Button
              key="credits"
              onClick={() => this.props.history.push("/payment/payment-options/whatsapp")}
              icon="🪙"
            >
              Buy Credit Limits
            </Button>
          ) : (
            <Button
              key="credentials"
              onClick={() => this.handleSetupClick(provider.name)}
              variant="secondary"
              icon="⚙️"
            >
              View/Edit Credentials
            </Button>
          ),
        ]
      : [
          <Button
            key="setup"
            onClick={() => this.handleSetupClick(provider.name)}
            icon="🚀"
          >
            Setup Now
          </Button>,
        ];

    return (
      <IntegrationCard
        key={provider.name}
        icon={this.providerIconGetter(provider.name)}
        title={provider.name}
        subtitle="WhatsApp Provider"
        badge={isSetup ? "Configured" : "Not Setup"}
        walletBalance={showWallet ? this.state.whatsappWalletBalance : null}
        isActive={isActive}
        onToggleActive={() => this.handleToggleActive(provider.id)}
        showToggle={isSetup}
        actions={actions}
      />
    );
  };

  render() {
    if (this.state.loading) return <LoadingSpinner />;

    return (
      <Section>
        <SectionHeader
          title={initialIntegrationsData.whatsapp.title}
          description={initialIntegrationsData.whatsapp.description}
        />
        <Grid minWidth="380px">
          {this.state.providers.map((provider) => this.renderProviderCard(provider))}
        </Grid>
      </Section>
    );
  }
}

export default WhatsAppIntegration;